"use client"
import './style.css';
import React, { Fragment, useEffect, useState } from 'react'
import QRCode from "react-qr-code";
import { http_request } from '../../../libs/connection';
import { BASE_ROUTE, ROOT_ADDR, SESSION_EXPIRED_CODE } from '../../../config';
import { createTimeString, numberToCash, auth, getOrderStatus, numberWithComma } from '../../../libs/lib';
import { Button, FormControl, Modal, Toast, ToastContainer } from 'react-bootstrap';
import { BsArrowReturnLeft } from 'react-icons/bs';
import Progress from '../../../components/progress';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Decimal from 'decimal.js';

function OutsourcingDetail() {
    const MAX_COLUMNS = 6;
    const LINES_PER_ROW = 3;//每一个 row 有3行组成所以空白行也 * 3
    const navigate = useNavigate();
    const url_params = useParams();
    const location = useLocation();
    const { pathname } = location;
    const { os_odno } = url_params;
    const [is_loading, setLoadingStatus] = useState(false);
    const [order, setOrder] = useState({});
    const [editing_order, setEditingOrder] = useState({});
    const [empty_rows, setEmptyRows] = useState([LINES_PER_ROW]);
    const [order_editor_show, showOrderEditor] = useState(false);
    const [qc_remk, setQCRemk] = useState('');
    const [company_fd_no, setCompanyFDNo] = useState('');
    const [success_toast_show, showSuccessToast] = useState(false);
    const [error_toast_show, showErrorToast] = useState(false);
    const [success_message, setSuccessMessage] = useState('');
    const [error_message, setErrorMessage] = useState('');
    const [ship_orders, setShipOrders] = useState([]);
    const [ship_order_list_viewer_show, showShipOrderListViewer] = useState(false);


    useEffect(()=>{
        loadOrder();
        loadShipOrders();
    }, [pathname, os_odno]);

    function loadOrder(){
        if(!os_odno) return;
        let params = {
            os_odno
        };
        http_request('/outsourcingOrder/get', 'POST', params).then(res=>{
            if(res.success){
                let raw_data = res.data.outsourcing_orders;
                let order = raw_data[0] ?? {};
                order.detail = raw_data.filter(od=>od.flag !== 'D').map(row=>{
                    let r = Object.assign({}, row);
                    r.ch_qty2_number = calculateQtyNumber(row);
                    return r;
                });
                for(let i = 0 ; i < order.detail.length ; i++){
                    delete order.detail[i].detail;
                }
                let epr = 4 - order.detail.length;
                if(epr <= 0 ) epr = 1;
                epr *= LINES_PER_ROW;
                setEmptyRows((new Array(epr)).fill(1));
                setOrder(order);
            }else if(res.message === SESSION_EXPIRED_CODE){
                navigate(`${BASE_ROUTE}/logout`);
            }
        })
    }
    function loadShipOrders(){
        if(!auth("global.outsourcingShipOrder")) return;
        let params = {
            os_odno,
            rows: 9999
        };
        http_request('/outsourcingShipOrder/list', 'POST', params).then(res=>{
            if(res.success){
                setShipOrders(res.data.outsourcing_ship_orders || []);
            }else if(res.message === SESSION_EXPIRED_CODE){
                navigate(`${BASE_ROUTE}/logout`);
            }
        })
    }
    function submitOrder(){
        if(!company_fd_no?.length || company_fd_no?.length > 20){
          setErrorMessage('出货单号不可留白');
          showErrorToast(true);
          return;
        }
        let params = {
            os_odno,
            qc_remk,
            company_fd_no,
            qc_qty2: editing_order.detail[0].qc_qty2_number
        };
        
        setLoadingStatus(true);
        http_request('/outsourcingOrder/ship', 'POST', params).then(res=>{
            setLoadingStatus(false);
            if(res.success){
                showOrderEditor(false);
                showSuccessToast(true);
                setSuccessMessage('已建立出货单');
                setErrorMessage('');
                let new_list = [...ship_orders];
                new_list.push(res.data.outsourcing_ship_order);
                setShipOrders(new_list);
            }else if(res.message === SESSION_EXPIRED_CODE){
                showOrderEditor(false);
                navigate(`${BASE_ROUTE}/logout`);
            }else{
                showErrorToast(true);
                setErrorMessage(res.message);
            }
        })
    }
    function createShipOrder(){
        let new_form = Object.assign({}, order);
        new_form.detail = [...(new_form.detail || [])]; 
        setEditingOrder(new_form);
        setQCRemk('');
        setCompanyFDNo('');
        showOrderEditor(true);
    }
    function deleteShipOrder(fd_no, i){
        let rs = window.confirm(`确定删除出货单吗?`);
        if(!rs) return;

        let params = { fd_no };
        setLoadingStatus(true);
        http_request('/outsourcingShipOrder/delete', 'POST', params).then(res=>{
            setLoadingStatus(false);
            if(res.success){
                showSuccessToast(true);
                setSuccessMessage('已删除出货单');
                setErrorMessage('');
                let new_list = [...ship_orders];
                new_list.splice(i, 1);
                setShipOrders(new_list);
            }else if(res.message === SESSION_EXPIRED_CODE){
                navigate(`${BASE_ROUTE}/logout`);
            }else{
                showErrorToast(true);
                setErrorMessage(res.message);
            }
        });
    }
    function calculateQtyNumber(row){
      let n = row.os_qty2 - row.os_puqty + row.os_reqty + row.os_reqty2;
      if(n < 0) n = 0;
      return n;
    }
    return (
        <div id="page-outsourcing-detail" className='page'>
            <Progress show={is_loading} variant="primary" />
            <Modal
                show={ship_order_list_viewer_show}
                onHide={()=>{ showShipOrderListViewer(false); }}
                centered
            >
                <Modal.Body className='p-5 d-flex flex-column align-items-center justify-content-center'>
                    {
                        ship_orders.map((ship_order, s)=><div key={s} className="qr_block">
                            <QRCode
                                size={256}
                                className='qr-code mb-2'
                                value={`${ROOT_ADDR}/erp/outsourcing/ship/detail/${ship_order.fd_no}`}
                            />
                            <div className='fw-bold'>{ship_order.fd_no}</div>
                            <div>建立日期：{createTimeString('y-m-d', ship_order.date)}</div>
                            <div>签收日期：{ship_order.fd_date ? createTimeString('y-m-d', ship_order.fd_date) : '--'}</div>
                            <div>签收状态：[{getOrderStatus(ship_order.temp_no, ship_order.result)}]{ship_order.temp_no ? '已签收' : (ship_order.result ||'').replace(/^\d+\./, '')}</div>
                            <div>厂商出货单号：{ship_order.company_fd_no || '--'}</div>
                            <div className='mb-3'>备註：{ship_order.qc_remk}</div>
                            <div className='mb-3 mt-1 d-flex align-items-center justify-content-between'>
                                <Button 
                                    variant='danger' 
                                    size='sm' 
                                    className='px-2'
                                    onClick={()=>{
                                        deleteShipOrder(ship_order.fd_no, s);
                                    }}
                                    disabled={getOrderStatus(ship_order.temp_no, ship_order.result) !== '尚未签收'}
                                >
                                    删除出货单
                                </Button>
                                <Button 
                                    variant='success' 
                                    size='sm' 
                                    className='px-2'
                                    onClick={()=>{
                                        navigate(`${BASE_ROUTE}/outsourcing/ship/detail/${ship_order.fd_no}`);
                                    }}
                                >
                                    打开出货单
                                </Button>
                            </div>
                        </div>)
                    }
                    {
                        ship_orders.length === 0 ? <div>无出货单</div> : ''
                    }
                </Modal.Body>
                <Modal.Footer className='d-flex align-items-center justify-content-end'>
                    <Button size='sm' variant='danger' className='px-3' onClick={()=>{ showShipOrderListViewer(false); }}>关闭</Button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={order_editor_show}
                onHide={()=>{ showOrderEditor(false); }}
                size='lg'
            >
                <Modal.Header>
                    <span className='fs-5'>建立出货单</span>
                </Modal.Header>
                <Modal.Body>
                    <table>
                        <tbody>
                            <tr>
                                <td>{editing_order.os_odno}</td>
                            </tr>
                            <tr>
                                <td>{editing_order.ch_date}</td>
                            </tr>
                            <tr>
                                <td>{editing_order.cu_name}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div>
                        {
                            (editing_order.detail || []).map((row, r)=><div key={r} className={`p-3 mt-2 border `}>
                                <ul className=''>
                                    <li>{row.ch_seq}</li>
                                    <li>{row.el_name1}</li>
                                    <li>{row.ch_apno}</li>
                                    <li>{row.el_no}</li>
                                    <li>出货数量上限：{calculateQtyNumber(row)}</li>
                                    <li>出货数量：<input 
                                        style={{ width: 80 }}
                                        value={row.qc_qty2_number || ''} 
                                        onChange={e=>{
                                            var v = e.currentTarget.value;
                                            let new_form = Object.assign({}, editing_order);
                                            new_form.detail = [...(new_form.detail || [])];
                                            new_form.detail[r].qc_qty2_number = v;
                                            setOrder(new_form);
                                    }} />{row.ch_unit}</li>
                                    <li>单价：{numberToCash(row.ch_price)}</li>
                                </ul>
                            </div>)
                        }
                    </div>
                    <div className='mt-3'>
                        <FormControl
                            className='mb-2'
                            placeholder="厂商出货单号(至多20码)"
                            value={company_fd_no}
                            maxLength={20}
                            onChange={e=>{
                                setCompanyFDNo(e.currentTarget.value.toUpperCase());
                            }}
                        />
                        <FormControl
                            as="textarea"
                            rows={4}
                            value={qc_remk}
                            onChange={e=>{
                                setQCRemk(e.currentTarget.value);
                            }}
                            placeholder='备註'
                        />
                    </div>
                </Modal.Body>
                <Modal.Footer className='f-flex justify-content-between'>
                    <Button size='sm' variant='danger' className='px-3' onClick={()=>{ showOrderEditor(false); }}>取消</Button>
                    <Button 
                        size='sm' 
                        variant='success' 
                        className='px-3'
                        disabled={(editing_order.detail || []).filter(row=> row.qc_qty2_number > 0 ).length === 0}
                        onClick={()=>{ submitOrder(); }}
                    >建立出货单</Button>
                </Modal.Footer>
            </Modal>
            <ToastContainer 
                position='middle-bottom'
                style={{ zIndex: 1056 }}
                >
                <Toast 
                    show={success_toast_show} 
                    onClose={()=>{ showSuccessToast(false); }}
                    delay={2000}
                    autohide
                    bg="success"
                    className='text-white'
                >
                    <Toast.Header>
                        <strong className="me-auto">已完成</strong>
                    </Toast.Header>
                    <Toast.Body>{success_message}</Toast.Body>
                </Toast>
            </ToastContainer>
            <ToastContainer
                position='middle-bottom'
                style={{ zIndex: 1056 }}
            >
                <Toast 
                    show={error_toast_show} 
                    onClose={()=>{ showErrorToast(false); }}
                    delay={3000}
                    autohide
                    bg="danger"
                    className='text-white'
                >
                    <Toast.Header>
                        <strong className="me-auto">建立失败</strong>
                    </Toast.Header>
                    <Toast.Body>{error_message}</Toast.Body>
                </Toast>
            </ToastContainer>
            <div className={`bg-white d-block content`}>
                <div className={`d-flex align-items-center justify-content-between py-3 px-2 head-container`}>
                    <span className='text-secondary pe-5 d-flex align-items-center cursor-pointer' onClick={()=>{ navigate(-1) }}>
                        <BsArrowReturnLeft size={20} className='pe-2' />
                        <span>返回</span>
                    </span>
                    <span>
                        {
                            auth('global.outsourcingShipOrder') && <Button 
                                size='sm' 
                                variant='danger' 
                                className='px-2 me-1' 
                                disabled={ship_orders.length === 0} 
                                onClick={()=>{ showShipOrderListViewer(true); }}
                            >
                                出货单列表
                            </Button>
                        }
                        
                        <Button size='sm' variant='success' className='px-2' disabled={Object.keys(order).length === 0} onClick={()=>{ createShipOrder(); }}>建立出货单</Button>
                    </span>
                </div>
                <div className={`overflow-auto table-container`}>
                    <table className={`border border-dark m-auto  dtable`}>
                        <thead>
                            <tr>
                                <th className='text-center' colSpan={4}>
                                    <h1>凹凸精密机械有限公司</h1>
                                    <h3>外包单</h3>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan={3}>列印日期：{createTimeString('y/m/d')}</td>
                                <td className='text-end'>页：{1}/{1}</td>
                            </tr>
                            <tr>
                                <td>外包单号：{order.os_odno}</td>
                                <td>外包日期：{createTimeString('y/m/d', order.os_prdat)}</td>
                                <td>预交日期：{createTimeString('y/m/d', order.os_fdat)}</td>
                                <td>下料日期：{createTimeString('y/m/d', order.os_endat)}</td>
                            </tr>
                            <tr>
                                <td colSpan={2}>厂商代号：{order.cu_no}</td>
                                <td>币　　别：{order.od_name}</td>
                                <td>汇　　率：{order.os_rate}</td>
                            </tr>
                            <tr>
                                <td>经办代号：{order.cu_snam}</td>
                                <td>国内外别：{order.os_areana}</td>
                                <td>税　　别：{order.taxiddesc}</td>
                                <td>税　　率：{order.ie_rtax}</td>
                            </tr>
                            <tr>
                                <td colSpan={2}>料品编号：{order.el_no}</td>
                                <td>工单类别：{order.sort_desc}</td>
                                <td>图　　号：{order.prno_desc}</td>
                            </tr>
                            <tr>
                                <td colSpan={2}>品名规格：{order.el_name1}</td>
                                <td colSpan={2}>{order.el_size}</td>
                            </tr>
                            <tr>
                                <td>计价方式：{order.chtypedesc}</td>
                                <td colSpan={2}>外包方式：{order.sctypedesc}</td>
                                <td>外包数量：{order.os_qty2}</td>
                            </tr>
                            <tr>
                                <td>包工单价：{order.os_price1}</td>
                                <td>包工前价：{order.bef_price1}</td>
                                <td>包材单价：{order.os_price2}</td>
                                <td>包材前价：{order.bef_price2}</td>
                            </tr>
                            <tr>
                                <td></td>
                                <td>单据金额：{order.os_amt}</td>
                                <td>单据税额：{order.os_tax}</td>
                                <td>合计总额：{numberWithComma(Decimal.add(order.os_amt || 0, order.os_tax || 0))}</td>
                            </tr>
                            <tr>
                                <td>来源单别：{order.ar_rena1}</td>
                                <td colSpan={3}>MRP单号：{order.os_lnkno}</td>
                            </tr>
                            <tr>
                                <td colSpan={3}>交货地点：{order.os_adid}</td>
                                <td>已验数量：{/* 已验数量不知道 */}</td>
                            </tr>
                            <tr>
                                <td colSpan={4}>备　　註：{order.qc_remk}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table className={`border border-top-0 border-dark m-auto  dtable`}>
                        <tbody className='underline text-center'>
                            <tr className='fw-bold'>
                                <td className='text-start'>料品编号</td>
                                <td className='text-start'>版别</td>
                                <td className='text-start'>製程</td>
                                <td className='text-end'>库存量</td>
                                <td className='text-end'>核发量</td>
                                <td className='text-end'>原核发量</td>
                            </tr>
                            <tr className='fw-bold'>
                                <td className='text-start'>品名</td>
                                <td></td>
                                <td className='text-start'>规格</td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr className='underline fw-bold'>
                                <td></td>
                                <td></td>
                                <td className='text-start'>单位用量</td>
                                <td className='text-end'>累计发料</td>
                                <td className='text-end'>累计退料</td>
                                <td className='text-end'>可领量</td>
                            </tr>
                            {
                                (order.detail || []).map((row, r)=><Fragment key={r}>
                                    <tr>
                                        <td className='text-start'>{row.el_nod}</td>
                                        <td className='text-start'>{row.el_verd}</td>
                                        <td className='text-start'>{row.pt_name}</td>
                                        <td className='text-end'>{/* 库存不知道 */}</td>
                                        <td className='text-end'>{row.os_qty2_d}</td>
                                        <td className='text-end'>{row.os_aqty2_d}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan={2} className='text-start'>{row.el_name1d}</td>
                                        <td colSpan={4} className='text-start'>{row.el_sized}</td>
                                    </tr>
                                    <tr className="underline-dashed">
                                        <td></td>
                                        <td></td>
                                        <td className="text-start">{row.os_unqty}</td>
                                        <td className="text-end">{/* 累计发料不知道 */}</td>
                                        <td className="text-end">{/* 累计退料不知道 */}</td>
                                        <td className="text-end">{/* 可领量不知道 */}</td>
                                    </tr>
                                </Fragment>)
                            }
                            {
                                empty_rows.map((row, r)=><tr key={r}><td colSpan={MAX_COLUMNS}>　</td></tr>)
                            }
                        </tbody>
                    </table>
                    <table className='m-auto  dtable border border-dark border-top-0'>
                        <tbody>
                            <tr>
                                <td>{order.ar_relna}</td>
                            </tr>
                            <tr>
                                <td>{order.ar_asgna}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default OutsourcingDetail;
